import { useMutation } from "@tanstack/react-query";
import { getFoodItemsByBarcode } from "../../../api/diary-service";

const useBarcodeSearch = () => useMutation({ mutationFn: ({ ean }) => getFoodItemsByBarcode(ean) });

export default useBarcodeSearch;
